import React from 'react';
import { translateText } from '../../../helpers/LanguageHelper';

export default function CatalogStatus({ error, loading, count, retry }) {
    if (!error) return null;
    return <p role="status" className="text-center">
        {translateText(count ? 'Some products could not be refreshed. Showing the last loaded products.' : 'Products could not be loaded. Please check your connection.')}{' '}
        <button type="button" className="btn btn-sm btn-outline-secondary" disabled={loading} onClick={retry}>
            {translateText(loading ? 'Retrying...' : 'Try again')}
        </button>
    </p>;
}
